module.exports = __webpack_public_path__ + "img/tripdaze-1.6da15c72.jpg";